import { ViewModel, View } from "binder"
import { ActivityTypeEditorView } from "./activityTypeEditor-view"
import { IActivityType } from "../IActivityType";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class ActivityTypeEditorViewModel extends ViewModel implements IActivityType, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
    }
    GetDefaultView(): View<ViewModel> {
        return new ActivityTypeEditorView();
    }
    public getTypeId(): string {
        return "VM-69F244BD-CFC5-4611-927D-714646F42EDB"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;

    closePopup(result?: any) {

    }

    async cloneTo(activityType: IActivityType) {
        activityType.id = this.id;
        activityType.name = this.name;
        activityType.code = this.code;
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت نوع OP');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت کد OP تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('نوع OP با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت نوع OP', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push('نوع OP مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.code)) {
            result.push('کد OP مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(activityType: IActivityType): Promise<any>;
}

export class ActivityTypeInserter implements IServerUpdater {
    async execute(activityType: IActivityType): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ActivityTypeServices/CreateActivityType', {
                Name: activityType.name,
                Code: activityType.code
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class ActivityTypeUpdater implements IServerUpdater {
    async execute(activityType: IActivityType): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ActivityTypeServices/UpdateActivityType', {
                ActivityTypeId: activityType.id,
                Name: activityType.name,
                Code: activityType.code
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
